module.exports = __webpack_public_path__ + "img/CECA_Plasma.feec1dd5.png";